<!-- お支払い総額(購入確認画面) -->
<template>
  <div class="row total-price">
    <label class="name">料金</label>
    <div class="value">
      <span>{{ totalPrice.toLocaleString() }}</span> {{ $t("common.unit") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BgPaymentAmount",
  props: {
    totalPrice: {
      type: Number,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}

.row.total-price {
  align-items: flex-end;
}

.row.total-price .value span {
  font-size: 20px;
}
</style>
